import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Tabs} from "flowbite-react";
import { HiAdjustments, HiUserCircle, HiViewBoards } from "react-icons/hi";
import { MdAssignment, MdViewModule } from "react-icons/md";
import { FaChalkboardTeacher } from "react-icons/fa";
import {
  useGetClusterQuery,
  useGetCampusByNameQuery,
} from "../../../../graphql/generated.tsx";
import StudentsTab from "../../Components/ManageClusterTabs/StudentsTab.jsx";
import ManageCourseTab from "../../Components/ManageClusterTabs/ManageCourseTab.jsx";
import SettingsTab from "../../Components/ManageClusterTabs/SettingsTab.jsx";
import StaffManageTab from "../../Components/ManageClusterTabs/StaffManageTab.jsx";
import AdminLayout from "../../Layout/index.jsx";
import NetworkIndicator from "../../../Practice/Components/NetworkIndicator.jsx";
import ManageAssignmentTab from "../../Components/ManageClusterTabs/ManageAssignmentTab.jsx";
import ManageModuleTab from "../../Components/ManageClusterTabs/ManageModuleTab.jsx";
import Loader from "../../../../components/Loader.jsx";
const ClusterStudentListing = () => {
  const { clusterId, campusName } = useParams();
  const [isLoad, setIsLoad] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoad(false);
    }, 2000);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
  });

  const { data: ClusterData, loading: clusterLoading } = useGetClusterQuery({
    variables: { campusName, clusterId },
  });

  const { data: CampusIdData, loading: campusLoading } = useGetCampusByNameQuery({
    variables: { name: campusName },
  });

  const campusId = CampusIdData?.getCampusByName?.id;

  useEffect(() => {
    if (ClusterData && ClusterData.getCluster) {
      setFormData({
        name: ClusterData.getCluster.name || "",
      });
    }
  }, [ClusterData]);

  if (clusterLoading || campusLoading || isLoad) {
    return (
      <AdminLayout>
       
        <div className="flex items-center justify-center h-screen font-poppins">
       <Loader />
       </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <NetworkIndicator />
      <Tabs aria-label="Tabs with icons" style="underline">
        <Tabs.Item active title="Students" icon={HiUserCircle}>
          <StudentsTab
            campusId={campusId}
            clusterId={clusterId}
            ClusterData={ClusterData}
            campusName={campusName}
          />
        </Tabs.Item>

        <Tabs.Item title="Manage Courses" icon={HiViewBoards}>
          <ManageCourseTab campusName={campusName} clusterId={clusterId} />
        </Tabs.Item>
        <Tabs.Item title="Manage Assignment" icon={MdAssignment}>
          <ManageAssignmentTab campusName={campusName} clusterId={clusterId} ClusterData={ClusterData} />
        </Tabs.Item>
        <Tabs.Item title="Manage Module" icon={MdViewModule}>
          <ManageModuleTab campusName={campusName} clusterId={clusterId} />
        </Tabs.Item>
        <Tabs.Item title="Settings" icon={HiAdjustments}>
          <SettingsTab
            campusName={campusName}
            clusterId={clusterId}
            formData={formData}
            setFormData={setFormData}
            ClusterData={ClusterData}
          />
        </Tabs.Item>
        <Tabs.Item title="Staff Management" icon={FaChalkboardTeacher}>
          <StaffManageTab
            campusName={campusName}
            clusterId={clusterId}
            campusId={campusId}
            ClusterData={ClusterData}
          />
        </Tabs.Item>
      </Tabs>
    </AdminLayout>
  );
};

export default ClusterStudentListing;
